export const GHA_ANALYTICS_EVENTS = {
  JOB_TABLE_FILTER_APPLY: "gha_analytics:job_table_filter_apply",
  JOB_TABLE_FILTER_CLEAR: "gha_analytics:job_table_filter_clear",
  JOB_TABLE_SORT: "gha_analytics:job_table_sort",
  JOB_TABLE_ROW_CLICK: "gha_analytics:job_table_row_click",

  REPO_TABLE_FILTER_APPLY: "gha_analytics:repo_table_filter_apply",
  REPO_TABLE_FILTER_CLEAR: "gha_analytics:repo_table_filter_clear",
  REPO_TABLE_SORT: "gha_analytics:repo_table_sort",
  REPO_TABLE_ROW_CLICK: "gha_analytics:repo_table_row_click",

  REPO_FILTER_APPLY: "gha_analytics:repo_filter_apply",
  JOB_FILTER_APPLY: "gha_analytics:job_filter_apply",
  RUNNER_TYPE_FILTER_APPLY: "gha_analytics:runner_type_filter_apply",
  STATUS_FILTER_APPLY: "gha_analytics:status_filter_apply",
  REPO_FILTER_NAVIGATE: "gha_analytics:repo_filter_navigate",
  BRANCH_FILTER_APPLY: "gha_analytics:branch_filter_apply",

  CHART_FILTER_CLEAR: "gha_analytics:chart_filter_clear",

  SPLIT_GRAPH_SORT_METHOD_CHANGE:
    "gha_analytics:split_graph_sort_method_change",
  SPLIT_GRAPH_TOP_N_CHANGE: "gha_analytics:split_graph_top_n_change",
  SPLIT_GRAPH_DIMENSION_CHANGE: "gha_analytics:split_graph_dimension_change",
  SPLIT_GRAPH_OPEN: "gha_analytics:split_graph_open",
  SPLIT_GRAPH_REPO_NAVIGATE: "gha_analytics:split_graph_repo_title_click",

  VIEW_CHANGE: "gha_analytics:view_change",
  BREADCRUMB_REPO_NAVIGATE: "gha_analytics:breadcrumb_repo_navigate",
  BREADCRUMB_ALL_REPOS_CLICK: "gha_analytics:breadcrumb_all_repos_click",

  JOB_DURATION_HISTOGRAM_GRANULARITY_CHANGE:
    "gha_analytics:job_duration_histogram_granularity_change",
  JOB_DURATION_PERCENTILE_LEGEND_HOVER:
    "gha_analytics:job_duration_percentile_legend_hover",
  JOB_DURATION_PERCENTILE_EXEMPLAR_CLICK:
    "gha_analytics:job_duration_percentile_exemplar_click",
} as const;

export const DOCKER_ANALYTICS_EVENTS = {
  VIEW_CHANGE: "docker_analytics:view_change",

  REPO_FILTER_APPLY: "docker_analytics:repo_filter_apply",
  REPO_FILTER_CLEAR: "docker_analytics:repo_filter_clear",
  DOCKERFILE_FILTER_APPLY: "docker_analytics:dockerfile_filter_apply",
  DOCKERFILE_FILTER_CLEAR: "docker_analytics:dockerfile_filter_clear",

  REPO_TABLE_SORT: "docker_analytics:repo_table_sort",
  REPO_TABLE_ROW_CLICK: "docker_analytics:repo_table_row_click",
  DOCKERFILE_TABLE_SORT: "docker_analytics:dockerfile_table_sort",

  SPLIT_GRAPH_OPEN: "docker_analytics:split_graph_open",
  SPLIT_GRAPH_REPO_NAVIGATE: "docker_analytics:split_graph_repo_navigate",
  REPO_FILTER_NAVIGATE: "docker_analytics:repo_filter_navigate",
  BREADCRUMB_REPO_NAVIGATE: "docker_analytics:breadcrumb_repo_navigate",
  BREADCRUMB_ALL_REPOS_CLICK: "docker_analytics:breadcrumb_all_repos_click",
} as const;

export const MIGRATION_WIZARD_EVENTS = {
  // `source` names the entry point (see MigrationWizardOpenSource); older
  // events have none and may come from either the sidebar or Home.
  OPEN: "migration_wizard:open",
  // `step` is the step the dialog was on when dismissed.
  CLOSE: "migration_wizard:close",
  REPOSITORY_SELECT: "migration_wizard:repository_select",
  DOCKER_CACHING_SELECT: "migration_wizard:docker_caching_select",
  CHECKOUT_CACHING_SELECT: "migration_wizard:checkout_caching_select",
  PULL_REQUEST_SELECT: "migration_wizard:pull_request_select",
  PULL_REQUEST_VIEW: "migration_wizard:pull_request_view",
  PULL_REQUEST_GENERATE: "migration_wizard:pull_request_generate",
} as const;

export const CORE_ANALYTICS_EVENTS = {
  ERROR: "error",
  PAGE_VIEW: "$pageview",
  PAGE_LEAVE: "$pageleave",
  LOGIN_BUTTON_CLICK: "login_button_click",
  DATE_RANGE_CHANGE: "date_range_change",
  DATE_RANGE_CUSTOM_SELECT: "date_range_custom_select",
  DATE_RANGE_CHART_DRAG: "date_range_chart_drag",
} as const;

export const CACHE_ANALYTICS_EVENTS = {
  TAB_CHANGE: "repository_cache:tab_change",
} as const;

export const VM_METRICS_ANALYTICS_TYPES = {
  VM_METRICS_CHART_LEGEND: "vm_metrics:chart_legend",
  VM_METRICS_STEP_TRACE: "vm_metrics:step_trace",
} as const;

export const VM_METRICS_EVENTS = {
  VM_METRICS_CHART_HOVER: "vm_metrics:chart_hover",
  VM_METRICS_CHART_CLICK: "vm_metrics:chart_click",
  VM_METRICS_STAT_CARD_HOVER: "vm_metrics:stat_card_hover",
  VM_METRICS_STAT_CARD_CLICK: "vm_metrics:stat_card_click",
} as const;

export const SLACK_INSTALL_EVENTS = {
  // Includes the install source as a property.
  CODESMITH_CONNECT_SLACK_TAB_CLICK:
    "slack_install:codesmith_connect_slack_tab_click",
} as const;

export const JOB_DETAILS_EVENTS = {
  // Fired when the user clicks "Debug with Codesmith" on a failed job's
  // details page (header action row). Navigates to a prefilled Codesmith
  // session that root-causes the failure and opens a PR with a fix.
  DEBUG_WITH_CODESMITH_CLICK: "job_details:debug_with_codesmith_click",
} as const;

export const CANVAS_EVENTS = {
  // Fired once per asset view when the asset resolves. `is_canvas`
  // distinguishes canvas artifacts from other attachments handled by the view.
  VIEWED: "canvas:viewed",
  // Fired once per asset view with `result`, `asset_uuid`, `surface`, and an
  // optional `$groups.org`; failures also include categorical `illegal_import`.
  // Raw render error content is excluded.
  RENDER_RESULT: "canvas:render_result",
  // Fired when the standalone page's "Download PDF" action opens the print
  // dialog.
  PDF_EXPORT: "canvas:pdf_export",
} as const;

// Report events (captured through proofAnalytics.tsx) carry
// `proof_session_id` (the Proof child session) and `surface` (ProofSurface);
// report-scoped ones add `repository` and `pr_number`. GitHub and Slack report
// links carry a `ref` that becomes `source` on REPORT_VIEWED. Adoption events
// (captured through proofAdoptionAnalytics.ts) carry `$groups.org` instead.
// The backend sends `proof_footer_button_clicked` (`variant`, `outcome`) for
// the PR footer's Proof button and `proof:run_started` (CaptureProofRunStartedAnalytics).
// The admin onboarding funnel (ProofOnboardingFunnelProvider) queries
// ONBOARDING_VIEWED, ENABLE_CLICKED, ENABLED and `proof:run_started` by name.
export const PROOF_EVENTS = {
  // The /[org]/proof onboarding rendered, with `proof_on` (already set up for
  // the viewer) and `org_admin`.
  ONBOARDING_VIEWED: "proof:onboarding_viewed",
  // `scope` (`self` | `team`) and `surface` (`onboarding` | `report_dock` |
  // `settings`); the report dock's links to the onboarding.
  ENABLE_CLICKED: "proof:enable_clicked",
  // `step` (`members` | `repositories`) and `surface`.
  TEAM_SETUP_STEP_COMPLETED: "proof:team_setup_step_completed",
  // Every enable save succeeded: `scope`, `surface` and the resulting `mode`;
  // team enables add `repository_scope`, `repository_count` and `member_count`.
  ENABLED: "proof:enabled",
  // A saved mode change: `from`, `to`, `target` (`self` | `team` | `member`)
  // and `surface`; member saves add `member_count`, one event per from/to pair.
  MODE_CHANGED: "proof:mode_changed",
  // A missing-secrets prompt was followed, with `surface`.
  MISSING_SECRETS_OPENED: "proof:missing_secrets_opened",
  // The report became visible in the workspace pane. `source` is the landing
  // `ref` (e.g. `proof_github_report`, `proof_slack_dm`) for the report the
  // page loaded on, else `dashboard`.
  REPORT_VIEWED: "proof:report_viewed",
  // The report left view (pane closed, tab or run switched), with `dwell_ms`.
  // A page closed while the report shows sends none.
  REPORT_CLOSED: "proof:report_closed",
  CARD_CLICKED: "proof:card_clicked",
  CLAIM_EXPANDED: "proof:claim_expanded",
  // A capture was shown on purpose: an evidence tab switch or the lightbox.
  EVIDENCE_VIEWED: "proof:evidence_viewed",
  LIGHTBOX_ACTION: "proof:lightbox_action",
  OUTBOUND_CLICKED: "proof:outbound_clicked",
  RECORDING_PLAYED: "proof:recording_played",
  // Once per recording per milestone (25, 50, 75, 100) of its length actually
  // played; seeks and scrubs add nothing.
  RECORDING_PROGRESS: "proof:recording_progress",
  RECORDING_FULLSCREEN: "proof:recording_fullscreen",
  RECORDING_RATE_CHANGED: "proof:recording_rate_changed",
  RECORDING_TRANSCRIPT_TOGGLED: "proof:recording_transcript_toggled",
  RECORDING_TRANSCRIPT_SEEKED: "proof:recording_transcript_seeked",
  RECORDING_CHAPTER_LOOP_TOGGLED: "proof:recording_chapter_loop_toggled",
} as const;

export const DIFF_VIEWER_EVENTS = {
  // Fired once each time a surface of the Changes pane enters a user-visible
  // error or degraded state, with `error_state` naming it (see
  // DiffViewerErrorState) and `feature: "diff_viewer"` for filtering.
  ERROR: "codesmith_diff_viewer:error",
} as const;

export const DIFF_VIEWER_FEATURE = "diff_viewer";

export const CANVAS_SURFACE = {
  PAGE: "page",
  PANE: "pane",
} as const;

export const CANVAS_RENDER_RESULT = {
  OK: "ok",
  COMPILE_ERROR: "compile_error",
  RUNTIME_ERROR: "runtime_error",
} as const;

export const MONITORS_EVENTS = {
  CREATE_MONITOR_CLICK: "monitors:create_monitor_click",
  MONITOR_ROW_CLICK: "monitors:monitor_row_click",
  TABLE_SORT: "monitors:table_sort",
  LOAD_MORE_CLICK: "monitors:load_more_click",
  MUTE_CLICK: "monitors:mute_click",
  RESOLVE_CLICK: "monitors:resolve_click",
  EDIT_CLICK: "monitors:edit_click",
  DUPLICATE_CLICK: "monitors:duplicate_click",
  DELETE_CLICK: "monitors:delete_click",

  FLOW_OPEN: "monitors:flow_open",
  FLOW_STEP_COMPLETE: "monitors:flow_step_complete",
  FLOW_STEP_BACK: "monitors:flow_step_back",
  FLOW_CANCEL: "monitors:flow_cancel",
  FLOW_CREATE_SUCCESS: "monitors:flow_create_success",
  FLOW_CREATE_FAILURE: "monitors:flow_create_failure",
  FLOW_UPDATE_SUCCESS: "monitors:flow_update_success",
  FLOW_UPDATE_FAILURE: "monitors:flow_update_failure",

  MUTE_CLICK_DETAIL: "monitors:mute_click_detail",
  RESOLVE_CLICK_DETAIL: "monitors:resolve_click_detail",
  EDIT_CLICK_DETAIL: "monitors:edit_click_detail",
  DELETE_CLICK_DETAIL: "monitors:delete_click_detail",
  VM_RETENTION_END_CLICK: "monitors:vm_retention_end_click",
  CREATE_MONITOR_FROM_RUN_CLICK: "monitors:create_monitor_from_run_click",
  DEBUG_WITH_CODESMITH_CLICK: "monitors:debug_with_codesmith_click",
} as const;

// The Sandboxes coming-soon page. `INTEREST_REGISTERED` carries `use_cases`,
// `peak_vcpu`, `interface` and `can_wait`.
export const SANDBOXES_EVENTS = {
  INTEREST_REGISTERED: "sandboxes:interest_registered",
} as const;
